import { RequestService } from '../../../../common/services/RequestService';
import { CREATE_EMPLOYEE } from '../constants';

import {
  dataAdjustmentRequest,
  dataAdjustmentResponse,
} from './dataAdjustment';

export const createEmployeeRequest = async (idProfile, formData) => {
  const response = await RequestService.post(
    CREATE_EMPLOYEE + idProfile,
    dataAdjustmentRequest(formData)
  );

  const data = dataAdjustmentResponse(response.data);
  return {
    id: data.profileId,
    data,
  };
};
